// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_82-4";
export var collapsed = "_82-1";
export var headerBar = "_82-0";
export var leftHeaderContent = "_82-3";
export var subjectContainer = "_82-2";